import { render, staticRenderFns } from "./ArrowControl.vue?vue&type=template&id=5e784230&scoped=true&"
import script from "./ArrowControl.vue?vue&type=script&lang=js&"
export * from "./ArrowControl.vue?vue&type=script&lang=js&"
import style0 from "./ArrowControl.vue?vue&type=style&index=0&id=5e784230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e784230",
  null
  
)

export default component.exports